import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAquaman = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "#1da193",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9 0.5C9 0.5 3.25 6.63 3.25 11.06C3.25 14.34 5.82 17 9 17C12.18 17 14.75 14.34 14.75 11.06C14.75 6.63 9 0.5 9 0.5ZM9 15.5C6.66 15.5 4.75 13.51 4.75 11.06C4.75 8.32 7.79 4.47 9 3.03C10.21 4.47 13.25 8.32 13.25 11.06C13.25 13.51 11.34 15.5 9 15.5Z" }), /* @__PURE__ */ _jsx("path", { d: "M9 13.9C10.53 13.9 11.77 12.63 11.77 11.06C11.77 10.65 11.45 10.31 11.05 10.31C10.65 10.31 10.33 10.65 10.33 11.06C10.33 11.8 9.73 12.4 9 12.4C8.6 12.4 8.28 12.74 8.28 13.15C8.28 13.56 8.6 13.9 9 13.9Z" })]
});
export { SvgIconAquaman as ReactComponent };
